export function memoize<T>(f: () => T): () => T {
  let result
  return () => {
    if (result !== undefined) {
      return result
    }
    result = f()
    return result
  }
}
